var map = {
	"./addtoprofilebutton_de.png": 124,
	"./addtoprofilebutton_en.png": 125,
	"./addtoprofilebutton_fr.png": 126,
	"./award_land_der_ideen.jpg": 127,
	"./b2b_award_logo.png": 128,
	"./cc.png": 129,
	"./certificate_sample.jpg": 130,
	"./clear.png": 131,
	"./companies.jpg": 132,
	"./course-cover-default.jpg": 133,
	"./course-page-card_big.png": 134,
	"./course-page-card_image.png": 135,
	"./course-page-card_image_inline.png": 136,
	"./course-page-card_inline.png": 137,
	"./course-page-card_small.png": 138,
	"./course-placeholder.jpg": 139,
	"./course_default.png": 140,
	"./download-easy-guide.jpg": 141,
	"./drag_dark.png": 142,
	"./drag_light.png": 143,
	"./draggable.png": 144,
	"./example_voucher_card_de.jpg": 145,
	"./example_voucher_card_en.jpg": 146,
	"./example_voucher_card_fr.jpg": 147,
	"./fabian.jpg": 148,
	"./female_speaker_bg.jpg": 149,
	"./h5p_docu_1.png": 150,
	"./h5p_docu_2.png": 151,
	"./loading.gif": 152,
	"./logo-iversity-without-padding.png": 153,
	"./logo-iversity.png": 154,
	"./logo_highres.png": 155,
	"./logo_iversity_springer.svg": 156,
	"./organisation_purchase.jpg": 157,
	"./petal_cutted.png": 158,
	"./posters_points.png": 159,
	"./professor_bg.jpg": 160,
	"./purchase_voucher_header.jpg": 161,
	"./referrals.jpg": 162,
	"./speech-bubble.svg": 163,
	"./voucher_card.png": 164,
	"./work_with_us.png": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;